import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['otherField', 'otherTextField']

  connect() {
    this.toggleOtherField()

    if (this.element.querySelector('select option[data-other="true"]')) {
      this.adjustOtherFromSelect(this.element.querySelector('select'))
    }
  }

  // These 2 are form radio_buttons field
  otherOptionSelected(e) {
    if (this.hasOtherTextFieldTarget) {
      this.otherTextFieldTarget.classList.remove('hidden')
    }
  }
  nonOtherOptionSelected(e) {
    if (this.hasOtherTextFieldTarget) {
      this.otherTextFieldTarget.classList.add('hidden')
    }
  }

  // This is for check_boxes field
  otherOptionToggle(e) {
    this.toggleOtherField()
  }

  // This is for select fields
  onSelect(e) {
    const selectField = e.target

    this.adjustOtherFromSelect(selectField)
  }

  isOtherChecked() {
    return this.otherFieldTarget.matches(':checked')
  }

  toggleOtherField() {
    if (!this.hasOtherFieldTarget) {
      return
    }

    const operation = this.isOtherChecked() ? 'remove' : 'add'
    this.otherTextFieldTarget.classList[operation]('hidden')
  }

  adjustOtherFromSelect(selectField) {
    const selectedOption = selectField.options[selectField.selectedIndex]

    this.otherTextFieldTarget.classList.toggle(
      'hidden',
      !(selectedOption.dataset.other == 'true')
    )
  }
}
